// extracted by mini-css-extract-plugin
export default {"ecgLoader":"EcgLoader_ecgLoader__YNnyb","pulse":"EcgLoader_pulse__lQ47u","dash":"EcgLoader_dash__QxdRe"};